import { defaultDataSource } from './data_source.jsx'
import enumConstants from '../enumConstants.json'

/**
 * @typedef {typeof import('../enumConstants.json').model_types} ModelType
 */

/** @type {ModelType} */
export const MODEL_TYPE = enumConstants.model_types

export const MODEL_TYPE_KEY_BY_VALUE = (value) => {
  return Object.keys(MODEL_TYPE).find(key => MODEL_TYPE[key] === value)
}

export const MODEL_TYPE_MAPPER = {
  [MODEL_TYPE.ACCOUNT]: {
    dataSource: (config) => defaultDataSource.account(config),
    displayExpr: (data) => data.no + ' - ' + data.name,
    searchExpr: () => ['no', 'name']
  },
  [MODEL_TYPE.BANK_ACCOUNT]: {
    dataSource: (config) => defaultDataSource.bank_account(config),
    displayExpr: (data) => data.bank_account_number + ' - ' + data.bank?.name,
    searchExpr: () => 'bank_account_number'
  },
  [MODEL_TYPE.EMPLOYEE]: {
    dataSource: (config) => defaultDataSource.employee(config),
    displayExpr: (data) => data.display_name,
    searchExpr: () => 'display_name'
  },
  [MODEL_TYPE.COMPANY]: {
    dataSource: (config) => defaultDataSource.company(config),
    displayExpr: (data) => data.name,
    searchExpr: () => 'name'
  }
}

export const modelDataSource = (company, model, type) => {
  let helper = null

  if (type) {
    helper = MODEL_TYPE_MAPPER[type]
  }

  let store = null

  if (helper) {
    const params = {
      searchExpr: helper.searchExpr(company.language_code),
      filter: []
    }

    store = helper.dataSource({ model, params })
  }

  return {
    store: store || [],
    pageSize: 20,
    paginate: true
  }
}
